import React, { useState, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AddReplyModal = ({ show, onHide, onSubmit }) => {
  const [replyContent, setReplyContent] = useState('');
  const quillRef = useRef(null);

  const handleSubmit = () => {
    onSubmit(replyContent);
    setReplyContent('');
    onHide();
  };

  return (
    <Dialog 
      open={show} 
      onClose={onHide}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          m: { xs: 1, sm: 2 },
          width: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 32px)' }
        }
      }}
    >
      <DialogTitle>Add Reply</DialogTitle>
      <DialogContent>
        <Box sx={{ 
          mt: 1,
          '& .quill': {
            display: 'flex',
            flexDirection: 'column',
            '& .ql-toolbar': {
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '4px 4px 0 0',
            },
            '& .ql-container': {
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '0 0 4px 4px',
              borderTop: 'none',
              fontSize: '1rem',
              flexGrow: 1
            },
            '& .ql-editor': {
              minHeight: '200px',
              fontSize: '1rem',
              padding: '12px',
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap'
            }
          }
        }}>
          <ReactQuill
            ref={quillRef}
            value={replyContent}
            onChange={setReplyContent}
            placeholder="Write your reply..."
            modules={{
              toolbar: [
                ['bold', 'italic'],
                ['clean']
              ]
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onHide}>Cancel</Button>
        <Button 
          variant="contained" 
          onClick={handleSubmit}
          disabled={!replyContent.trim()}
        >
          Reply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddReplyModal; 